export const paper = (isMobile) => {
    return {
        height: isMobile ? '100%' : '70%',
        width: isMobile ? '100%' : '500px',
    };
};
